<template>
  <transition-group
    name="fade"
    tag="div"
    class="entries-grid staff-directory"
  >
    <div
      v-for="result in results"
      class="staff-element"
      v-bind:class="{ hasThumbnail: result.headshot.length != 0 }"
      v-bind:key="result.id"
      :data-id="result.id"
    >
      <figure v-if="result.headshot.length != 0">
        <img
          v-for="(thumbnail, index) in result.headshot"
          v-lazy-src="thumbnail.url"
          :key="index"
          :alt="result.title + ' headshot'"
        />
      </figure>
      <div class="staff-content">
        <h3 class="is-smaller heading-3">{{result.title}}</h3>
        <span class="is-smaller">{{ result.jobTitle }}{{ schoolsString(result) }}</span>
        <div class="contact-info is-smaller is-serif">
          <span v-if="result.phoneNumber" v-html="formatPhoneNumbers(result.phoneNumber)"></span>
          <a v-if="result.emailAddress"
            :target="_blank"
            :href="'mailto:' + result.emailAddress"
          >Email</a>
          <a v-for="(link, index) in result.customLinks" :key="index" :href="link.linkField.url">{{ link.linkField.text }}</a>
        </div>
      </div>
    </div>
  </transition-group>
</template>

<script>
import { mapState } from 'vuex'

export default {
  methods: {
    formatPhoneNumbers (string) {
      let result = string.replace(
        /(?<!\d)(?:\((\d{3})\)\s?|(\d{3})[.-]|(\d{3})(?=\d{7}))(\d{3})[.-]?(\d{4})(?!\d)(?:\s*(?:x|ext\.?)\s*(\d+))?/gi,
        (_, g1, g2, g3, g4, g5, ext) => {
          const area = g1 || g2 || g3
          const display = `(${area}) ${g4}-${g5}` + (ext ? ` x${ext}` : '')
          const tel = `+1${area}${g4}${g5}` + (ext ? `,${ext}` : '')
          return `<a href="tel:${tel}">${display}</a>`
        }
      )
      // Wrap label text + following link in a <span> so CSS a+span:before places | before the label
      result = result.replace(/<\/a>([^<]+)(<a href="tel:[^"]+">)(.*?)<\/a>/g, (_, between, openTag, linkText) => {
        return `</a><span>${between}${openTag}${linkText}</a></span>`
      })
      return result
    },
    schoolsString (result) {
      if (result.schoolBuilding.length) {
        const schoolsArr = []
        result.schoolBuilding.forEach(e => {
          schoolsArr.push(e.title)
        })
        return ', ' + schoolsArr.join(', ')
      } else {
        return ''
      }
    }
  },
  computed: {
    ...mapState('staff', ['results'])
  }
}
</script>
